export interface IPassword {
  password: string | null;
}
